* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.has-bullet {
  position: relative;
  font-family: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  transform: translateY(0px);

  .bullet {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    border-radius: 50%;
    margin-right: 6px;
    background-color: var(--red-alert-500-severe);
  }
}

:host([center]) .has-bullet {
  justify-content: center;

  .bullet {
    margin-right: 0;
  }
}

:host([reverse]) .has-bullet {
  flex-direction: row-reverse;

  .bullet {
    margin-right: 0;
    margin-left: 6px;
  }
}
